import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { ICompany, ListManufacturersRequest, SituViewWebApiClient } from 'situview-webapi-client';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { Role } from 'src/app/shared/models/role.model';
import { Router } from '@angular/router';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';

@Component({
  selector: 'themes-imported-product-replacements',
  templateUrl: './themes-imported-product-replacements.component.html',
  styleUrls: ['./themes-imported-product-replacements.component.scss']
})

export class ThemesImportedProductReplacementsComponent extends SituBaseComponent {
  viewControls = {
    pageIndex: 0,
    pageSize: 25,
    totalItems: 0,
    pageSizeOptions: [25, 50, 100],
    displayedColumns: ['name', 'logoUrl', 'disabled', 'cta']
  } as ManufacturersListViewControls;

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  enabledOnly: boolean = true;
  previousSearchTerm = "";
  searchTerm = "";
  admin = false;
  manufacturersDataSource = new MatTableDataSource<ICompany>();

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewWebApiClient: SituViewWebApiClient,
    private router: Router,
    private breadcrumbService: BreadcrumbService) {
    super(authService, stateService);
  }

  protected onSelectedCompanyChange(): void {
    this.loadManufacturers();
  }

  onClickAddCompany() {
    this.router.navigate([`/admin/companies/add`]);
  }

  loadManufacturers() {
    this.loading = true;

    let request = new ListManufacturersRequest();

    if (this.searchTermChanged()) this.resetSearch();
    request.pageNumber = this.viewControls.pageIndex + 1;
    request.pageSize = this.viewControls.pageSize;
    request.searchTerm = this.searchTerm;
    request.enabled = this.enabledOnly;
    this.previousSearchTerm = this.searchTerm;

    return this.situViewWebApiClient.listManufacturers(request).then(response => {
      this.manufacturersDataSource.data = response.manufacturers ?? [];
      this.viewControls.totalItems = response.totalItems ?? 0;
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  onEditManufacturer(companyId: string) {
    this.router.navigate([`/admin/companies/${companyId}`]);
  }

  onViewCompany(manufacturerId: string) {
    this.router.navigate([`/admin/companies/${manufacturerId}/dashboard`]);
  }

  onPageChange(event: PageEvent) {
    this.viewControls.pageSize = event.pageSize;
    this.viewControls.pageIndex = event.pageIndex;

    this.loadManufacturers();
  }

  resetSearch() {
    this.viewControls.pageIndex = 0;
    this.viewControls.pageSize = 25;
    this.viewControls.totalItems = 0;
  }

  private searchTermChanged(): boolean {
    return this.searchTerm.toLowerCase() !== this.previousSearchTerm.toLowerCase();
  }
}

interface ManufacturersListViewControls {
  pageSize: number;
  pageIndex: number;
  pageNumber: number;
  totalItems: number;
  pageSizeOptions: number[];
  displayedColumns: string[];
}
